import * as React from 'react';
import List from './time/List';
import Track from './time/Track';
import Tasks from './tasks/Tasks';
import { Router, Route, parseQuery } from './router';
import Header from './Header';
import Profile from './profile/Profile';
import LayoutManager from './LayoutManager';

export default class App extends React.Component {
  static default: App | undefined;

  componentWillMount() {
    App.default = this;
    Router.shared.attach(this);
    LayoutManager.shared.startObserving();
  }

  componentWillUnmount() {
    Router.shared.detach();
    App.default = undefined;
    LayoutManager.shared.stopObserving();
  }

  render() {
    const name = localStorage.getItem('name')
    parseQuery();
    Router.shared.onRenderStart();
    return (
      <div className="container">
        <Header />
        {!name ? <Profile /> : (
          <React.Fragment>
            <div className="content">
              <Route path="/time/track">
                <Track />
              </Route>
              <Route path="/time/list">
                <List />
              </Route>
              <Route path="/tasks">
                <Tasks />
              </Route>
              <Route path="/profile">
                <Profile />
              </Route>
              <Route path="*">
                <Tasks />
              </Route>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.tsx